import React, { useState, useEffect } from "react";
import TradingJournalGuide from "../../components/tradingJournal/TradingJournalGuide";
import PerformanceChart from "../../components/tradingJournal/PerformanceChart";
import BehaviorJournalForm from "../../components/tradingJournal/BehaviorJournalForm";
import BehaviorView from "../../components/tradingJournal/BehaviorView";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../../components/ui/collapsible";
import {
  TradeJournalProvider,
  useTradeJournal,
} from "../../context/TradeJournalContext";
import DateRangeSelector from "../../components/tradingJournal/DateRangeSelector";
import { useIsMobile } from "../../hooks/use-mobile";
import { cn } from "../../lib/utils";
import RoiSection from "../../components/tradingJournal/RoiSection";
import {

  Typography,

} from "antd";
const { Title, Text } = Typography;

const JournalContent = () => {
  const [showForm, setShowForm] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const isMobile = useIsMobile();

  const { editingEntry, behaviorEntries } = useTradeJournal();

  useEffect(() => {
    if (editingEntry) {
      setShowForm(true);
    }
  }, [editingEntry]);

  // Use behaviorEntries instead of entries to match the expected type
  const filteredBehaviorEntries = behaviorEntries;

  return (
    <main className="pt-10 pb-20 bg-darkMode-background">
      <div className="flex items-center gap-1 mx-6 md:px-0">
        <div>
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            Trading <span className="text-market-teal">Journal</span>
          </h1>
          <Text className="text-sm text-darkMode-subText px-4 md:px-0">
            Log your trades, track performance, and improve your trading
            strategy over time.
          </Text>
        </div>
      </div>
      <section className="container mx-auto px-4 max-w-6xl">

        <Collapsible
          open={showGuide}
          onOpenChange={setShowGuide}
          className="mb-6"
        >
          <CollapsibleContent className="overflow-hidden transition-all duration-300 ease-in-out bg-white/5 rounded-lg border border-white/10 p-4 mt-4">
            <TradingJournalGuide />
          </CollapsibleContent>
        </Collapsible>

        <div
          className={cn(
            "mb-6 bg-white/5 rounded-lg border border-white/10",
            isMobile ? "p-3" : "p-4"
          )}
        >
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-sm text-white/70 font-medium">
              Select Time Period
            </h3>
          </div>
          <DateRangeSelector className="flex-wrap gap-2" />
        </div>

        <Collapsible
          open={showForm}
          onOpenChange={setShowForm}
          className="mb-8"
        >
          <CollapsibleContent className="overflow-hidden transition-all duration-300 ease-in-out">
            <BehaviorJournalForm onSubmit={() => setShowForm(false)} />
          </CollapsibleContent>
        </Collapsible>

        <div className="mb-8">
          <div className="space-y-8">
            <div>
              <PerformanceChart />
            </div>
            <div>
              <BehaviorView />
            </div>
          </div>
        </div>

        {/* ROI section directly above Recent Journal Entries */}
        <RoiSection />

        {/* Note: Removed the duplicate BehaviorEntriesTable component that was here.
              The BehaviorEntriesTable is already included inside the BehaviorView component above */}
      </section>
    </main>
  );
};

const TradingJournal = () => {
  return (
    <TradeJournalProvider>
      <JournalContent />
    </TradeJournalProvider>
  );
};

export default TradingJournal;
